<ion-content>
  <div class="closeWrapper" (click)="close()">
    X
  </div>
  <ion-img class="imgClass" src="assets/gif/add-home-v3.gif"></ion-img>
</ion-content>
